<template>
  <full-screen-loader v-if="!this.prescription"/>
  <smd-one-col-layout class="fulfillment-mode-selection"
                      content-styles="fulfillment-mode-selection__content-style dark-light-bg"
                      v-else>
    <smd-header slot="header" nav>
      <span class="ns-icon-ico027"
            slot="left-actions"
            v-if="$isMobile"
            @click="goBack"/>
      <span class="ns-icon-ico027"
            slot="right-actions"
            v-else
            @click="goBack"/>
      <text-string label-id="txt039"/>
      <span class="ns-icon-ico001"
            slot="right-actions"
            v-if="$isMobile">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <template v-if="isIssued">
      <div class="smd-form__row">
        <text-string label-id="txt156"
                     :props="{'strings': [coupon.description]}"/>
      </div>

      <div class="flex-row--center-x m-b-30">
        <text-string label-id="txt330"
                     class="m-r-5 fulfillment-mode-selection__chance-to-claim-text"
                     :class="alertClass"/>
        <coupon-countdown-timer :class="{'m-l-20': $isDesktop}"
                                :start-time="startTimeString"
                                :end-time="endTimeString"
                                :large="$isDesktop"
                                :trans="transConfig"/>
      </div>

      <div class="fulfillment-mode-selection__card smd-form__col smd-list--panels">
        <div class="smd-list__item fulfillment-mode-selection__card-item"
             @click="fulfillmentModeSelection($options.FulfillmentType.DELIVERY)">
          <img src="@/assets/icons/ico063.svg" alt="">
          <text-string class="text-center" label-id="txt037"/>
        </div>

        <div class="flex-row-center-xy-spaced">
          <smd-or-divider/>
        </div>

        <div class="smd-list__item fulfillment-mode-selection__card-item"
             @click="fulfillmentModeSelection($options.FulfillmentType.PICK_UP)">
          <img src="@/assets/icons/ico064.svg" alt="">
          <text-string label-id="txt038"/>
        </div>
      </div>
    </template>
    <template v-else-if="isRedeemed">
      <div class="cover">
        <div class="flex-center--xy">
          <div class="Paragraph1 gray-400">
            This sample code has
          </div>
          <div class="Paragraph1 gray-400">
            already been claimed
          </div>
        </div>
      </div>
    </template>
  </smd-one-col-layout>
</template>

<script>
  // import Vue from 'vue';
  import {mapActions, mapGetters} from "vuex";
  import {mapFields} from "vuex-map-fields";
  import {
    ACTION_RESET_PHARMACY_ORDER,
    GETTER_FILES,
    GETTER_ONGOING_MEDICINE_ORDERS,
    GETTER_FIRSTNAME,
    GETTER_LASTNAME,
    GETTER_MOBILENUMBER,
  } from "@/store/types";
  import {
    DEFAULT_PHARMACIES,
    COUPON_FULFILLMENT_MODE,
  } from '@/reference/medicine';
  import CountdownStartEndTimeMixin from '@/mixins/services/countdown-start-end-time-mixin';
  import CouponCountdownTimer from '@/components/coupon-countdown-timer';
  import FulfillmentType from '@/reference/fulfillment-type';
  import ModalWatsonBranchList from '@/modals/modal-watsons-branch';
  import Routes from '@/router/routes';
  import MedicineOrderRequestMixin from '@/mixins/services/medicine-order-request-mixin';
  import {Reference} from "smd-vue-scaffold";

  export default {
    name: "fulfillment-mode-selection",
    mixins: [
      CountdownStartEndTimeMixin,
      MedicineOrderRequestMixin,
    ],
    components: {CouponCountdownTimer},
    data() {
      return {
        transConfig: {
          "days": "Days",
          "hours": "Hrs",
          "minutes": "Mins",
          "seconds": "Secs",
        },
      }
    },
    computed: {
      ...mapGetters({
        files: GETTER_FILES,
        serviceOrders: GETTER_ONGOING_MEDICINE_ORDERS,
        storeFirstName: GETTER_FIRSTNAME,
        storeLastName: GETTER_LASTNAME,
        storeMobileNumber: GETTER_MOBILENUMBER,
      }),
      ...mapFields({
        mobilenumber: 'mobilenumber',
        firstname: 'firstname',
        lastname: 'lastname',
        fulfillmentmode: 'fulfillmentmode',
        partnercode: 'partnercode',
        availmentCode: 'availmentCode',
      }),
      alertClass() {
        const now = new Date().getTime();

        const passTime = new Date(this.endTime).getTime() - now;
        const daysLeft = Math.floor(passTime / (1000 * 60 * 60 * 24));


        return daysLeft <= 7 && daysLeft > -1 ? 'text-alert' : '';
      },
      isIssued() {
        const possibleValues = ['issued', 'availed'];
        return possibleValues.includes(this.coupon.status.toLowerCase());
      },
      isRedeemed() {
        return this.coupon.status.toLowerCase() === 'redeemed'
      },
      isExpired() {
        const now = new Date().getTime();
        const passTime = new Date(this.endTime).getTime() - now;
        const daysLeft = Math.floor(passTime / (1000 * 60 * 60 * 24));

        return daysLeft < 0 ? 'expired' : '';
      },
      prescription() {
        const channelid = this.$route.params[Routes.PHARMACY_FULFILLMENT_MODE_PARAM]
        return this.files.find(file => file.channelid === channelid);
      },
      coupon() {
        return this.prescription.coupons[0];
      }
    },
    watch: {
      prescription: {
        handler(prescription) {
          if (prescription) {
            const [firstname, ...lastnameArray] = prescription.patientname.split(' ');
            this.firstname = firstname;
            this.lastname = lastnameArray.join(' ');
          } else {
            this.firstname = this.storeFirstName;
            this.lastname = this.storeLastName;
          }
        },
        immediate: true,
      },
      coupon: {
        handler(withCoupon) {
          this.partnercode = withCoupon ? DEFAULT_PHARMACIES.watsons : DEFAULT_PHARMACIES.NS_PHARMACY;
        },
        immediate: true,
      },
    },
    mounted() {
      this.mobilenumber = this.storeMobileNumber;
    },
    methods: {
      ...mapActions({
        resetOrdersToDefaultState: ACTION_RESET_PHARMACY_ORDER
      }),
      goBack() {
        this.$goBack();
        this.resetOrdersToDefaultState();
      },
      fulfillmentModeSelection(type) {
        if (type === FulfillmentType.DELIVERY) {
          this.fulfillmentmode = COUPON_FULFILLMENT_MODE.DELIVERY;
          this.$router.push({
            name: Routes.PHARMACY_WATSONS_ORDERS,
            params: {
              [Routes.PHARMACY_FULFILLMENT_MODE_PARAM]: this.$route.params[Routes.PHARMACY_FULFILLMENT_MODE_PARAM],
            }
          })
        } else {
          this.fulfillmentmode = COUPON_FULFILLMENT_MODE.PICKUP;
          this.$modal.open({
            component: ModalWatsonBranchList,
            size: this.$isMobile ? Reference.SmdModalSizes.xs : Reference.SmdModalSizes.md,
            props: {
              isBranchForPickup: true
            },
            onClose: (payload) => {
              if (payload) {
                this.availmentCode = payload ? payload.branchCode : '';
                this.submitCoupon();
              }
            },
          })
        }
      },
    },
    FulfillmentType
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .fulfillment-mode-selection__content-style {
    @include responsive(desktop) {
      padding: space(xl) !important;
    }

    > div {
      @include set-max-width($max-width: 900px);
    }
  }

  .fulfillment-mode-selection__card {
    @extend %layout--flex-center-xy;
    @include responsive(desktop) {
      margin-top: space(xxxl);
    }

    @at-root .expired & {
      opacity: 0.5;
      pointer-events: none;
    }
  }

  .fulfillment-mode-selection__chance-to-claim-text {
    @at-root .expired & {
      color: color(gray-400);
    }
  }

  .fulfillment-mode-selection__card-item {
    @extend %layout--flex-center-xy;
    width: 165px;
    height: 165px;
  }
</style>